import { render } from "./PrintLetterButton.vue?vue&type=template&id=355891e4&scoped=true"
import script from "./PrintLetterButton.vue?vue&type=script&lang=js"
export * from "./PrintLetterButton.vue?vue&type=script&lang=js"

import "./PrintLetterButton.vue?vue&type=style&index=0&id=355891e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355891e4"]])

export default __exports__